import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mock.exam');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mock-exam',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mock.exam/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageMockExamComponent implements OnInit {
    public loading: boolean = true;
    public tab: string = 'presets';  // presets, history
    public presets: any[] = [];
    public subjects: any[] = [];
    public history: any[] = [];

    public selectedPreset: any = null;
    public selectedSubjectId: string = '';
    public customCount: number = 20;
    public customTime: number = 30;
    public customDiffMin: number = 1;
    public customDiffMax: number = 5;

    public starting: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadPresets();
        await this.loadSubjects();
        await this.service.render();
    }

    public async loadPresets() {
        const res = await wiz.call("presets");
        if (res.code === 200) {
            this.presets = res.data.presets || [];
        }
    }

    public async loadSubjects() {
        const res = await wiz.call("subjects");
        if (res.code === 200) {
            this.subjects = res.data.rows || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadHistory() {
        const res = await wiz.call("history");
        if (res.code === 200) {
            this.history = res.data.rows || [];
        }
        await this.service.render();
    }

    public async setTab(t: string) {
        this.tab = t;
        if (t === 'history' && this.history.length === 0) {
            await this.loadHistory();
        }
        await this.service.render();
    }

    public selectPreset(preset: any) {
        this.selectedPreset = preset;
        if (preset.id === 'custom') {
            this.selectedSubjectId = '';
        } else {
            // 과목 코드로 매핑
            const subj = this.subjects.find((s: any) => {
                const code = preset.subject_code;
                if (code === 'korean') return s.name?.includes('한국사');
                if (code === 'world') return s.name?.includes('세계사');
                if (code === 'eastasia') return s.name?.includes('동아시아');
                return false;
            });
            this.selectedSubjectId = subj?.id || '';
            this.customCount = preset.question_count;
            this.customTime = preset.time_limit;
            this.customDiffMin = preset.difficulty_min;
            this.customDiffMax = preset.difficulty_max;
        }
        this.service.render();
    }

    public cancelSelect() {
        this.selectedPreset = null;
        this.selectedSubjectId = '';
        this.service.render();
    }

    public async startMockExam() {
        if (!this.selectedSubjectId) {
            await this.service.alert.show({ title: '알림', message: '과목을 선택해주세요.' });
            return;
        }

        this.starting = true;
        await this.service.render();

        const params: any = {
            subject_id: this.selectedSubjectId,
            question_count: this.customCount,
            time_limit: this.customTime,
            difficulty_min: this.customDiffMin,
            difficulty_max: this.customDiffMax,
            preset_id: this.selectedPreset?.id || 'custom'
        };

        const res = await wiz.call("start", params);
        this.starting = false;

        if (res.code === 200 && res.data.exam_id) {
            this.service.href(`/quiz/play/${res.data.exam_id}`);
        } else {
            await this.service.alert.show({
                title: '오류',
                message: res.data?.message || '모의고사를 시작할 수 없습니다.'
            });
            await this.service.render();
        }
    }

    public viewResult(exam: any) {
        this.service.href(`/quiz/result/${exam.id}`);
    }

    public formatDate(d: string): string {
        if (!d) return '-';
        return d.substring(0, 16).replace('T', ' ');
    }

    public getGradeColor(grade: number): string {
        if (grade <= 2) return 'text-blue-600';
        if (grade <= 4) return 'text-green-600';
        if (grade <= 6) return 'text-yellow-600';
        return 'text-red-500';
    }
}

export default PageMockExamComponent;